import React from 'react';
import { connect } from 'react-redux';
import { GridGapSizes } from '@ff-os/shared-react/components/grid/Grid';
import { List } from '@ff-os/shared-react/components/list/List';
import { ListItem } from '@ff-os/shared-react/components/list/ListItem';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { ColorChoice } from '@gift-variable-plugins/color-attribute-shared/ColorAttributeOptions';
import { selectChosenColorById, selectColorChoicesById, updateValueByIds } from '../_redux';
import { ColorAttributeDropdownItem } from './ColorAttributeDropdownItem';

export const _ColorAttributeDropdownList = ({
    choices, selected, update, gap
}: Props) => (
    <List gap={gap}>
        {choices.map(c => (
            <ListItem
                key={c.value} bordered={gap !== undefined}
                onClick={() => update(c.value)} active={c.value === selected.value}>
                <ColorAttributeDropdownItem {...c} />
            </ListItem>
        ))}
    </List>
);

type Props = {
    variableIds: string[];
    choices: ColorChoice[];
    selected: ColorChoice;
    update: (value: string) => void;
    gap?: GridGapSizes;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    selected: selectChosenColorById(state, ownProps.variableIds[0]!)!,
    choices: selectColorChoicesById(state, ownProps.variableIds[0]!)!
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    update: (size: string) => dispatch(updateValueByIds(ownProps.variableIds, size))
});

export const ColorAttributeDropdownList = connect(
    mapStateToProps,
    mapDispatchToProps
)(_ColorAttributeDropdownList);